<template>
    <div>
        <div class="columns toolbar-box is-multiline">
            <div class="column is-6-tablet is-3-desktop">
                <o-field>
                    <o-select :expanded="true" placeholder="Select Team" v-model="filters.team_id">
                        <option :value="null">Select Team</option>
                        <option :value="team.id" v-for="team in teams" v-bind:key="team.id">{{ team.name }}</option>
                    </o-select>
                </o-field>
            </div>
            <div class="column is-6-tablet is-3-desktop">
                <multicomplete
                    type="user"
                    field-name="full_name"
                    v-model="filters.users"
                    placeholder="Select Users"
                />
            </div>
            <div class="column is-6-tablet is-3-desktop">
                 <o-field>
                    <o-select :expanded="true" placeholder="Select Year" v-model="filters.year">
                        <option value="">Select Year</option>
                        <option value="grouped">Grouped</option>
                        <option :value="year" v-for="year in years" v-bind:key="year">
                            {{ year }}
                        </option>
                    </o-select>
                </o-field>
            </div>
            <div class="column is-6-tablet is-3-desktop">
                <o-field>
                    <o-select :expanded="true" placeholder="Select Month" v-model="filters.month">
                        <option value="">All Months</option>
                        <option :key="month.id" :value="month.id" v-for="month in months">
                            {{ month.name }}
                        </option>
                    </o-select>
                </o-field>
            </div>
        </div>

        <div class="columns reset-filter-wrapper">
            <div class="column">
                <div class="field is-grouped is-grouped-right">
                    <p class="control">
                        <a @click.prevent="toggleBillingsReimb" class="button is-default">
                            {{ isBillingReimbVisible ? 'Hide' : 'Show' }} Reimbursable
                        </a>
                    </p>

                    <p class="control" v-if="isResetFiltersButtonVisible">
                        <a @click.prevent="resetFilters" class="button is-default">
                            Reset filters
                        </a>
                    </p>
                </div>
            </div>
        </div>

        <div v-if="displayPeriod === 'grouped'">
            <grouped-table :data="data" heading="All Months" :team-id="filters.team_id" @row-clicked="fetchUserGroupedBillingData"  />
        </div>

        <div v-if="displayPeriod === 'weekly'">
            <total-table :data="data" :heading="selectedMonth" :team-id="filters.team_id" @row-clicked="fetchUserWeeklyBillingData" />

            <div class="columns">
                <div class="column">
                    <report-table :heading="headingForWeek(1)" :data="week1" :week="1" @row-clicked="fetchUserWeeklyBillingData" />
                </div>
                <div class="column">
                    <report-table :heading="headingForWeek(2)" :data="week2" :week="2" @row-clicked="fetchUserWeeklyBillingData" />
                </div>
            </div>

            <div class="columns">
                <div class="column">
                    <report-table :heading="headingForWeek(3)" :data="week3" :week="3" @row-clicked="fetchUserWeeklyBillingData" />
                </div>
                <div class="column">
                    <report-table :heading="headingForWeek(4)" :data="week4" :week="4" @row-clicked="fetchUserWeeklyBillingData" />
                </div>
            </div>
        </div>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isBillingModalActive" has-modal-card>
            <billing-modal :user-billing="userBilling" :heading="billingModalHeading" />
        </o-modal>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
import Multicomplete from './../../../components/Multicomplete'
import BillingModal from './../../../components/modals/Billing'
import GroupedTable from './billing-dashboard/GroupedTable'
import ReportTable from './billing-dashboard/ReportTable'
import TotalTable from './billing-dashboard/TotalTable'

    export default {
        components: {
            Multicomplete,
            ReportTable,
            TotalTable,
            GroupedTable,
            BillingModal,
        },

        data() {
            return {
                filters: {
                    year: (new Date).getFullYear(),
                    month: moment().format('MM'),
                    team_id: null,
                    users: [],
                    reimbursable: null
                },
                data: [],
                userBilling: [],
                isBillingModalActive: false,
                billingModalHeading: ''
            }
        },

        watch: {
            'filters.year'() {
                this.fetchData()
            },
            'filters.month'() {
                this.fetchData()
            },
            'filters.team_id'() {
                this.fetchData()
            },
            'filters.users'() {
                this.fetchData()
            },
            'userBilling'(value){
              value.map((item) => {
                this.fetchProjects({ id: item.project_id })
              });
            }
        },

        mounted() {
            this.fetchData()
        },

        methods: {
            ...mapActions(['toggleBillingsReimb', 'fetchProjects']),

            fetchData() {
                this.filters.reimbursable = this.isBillingReimbVisible ? 1 : 0
                let params = _.clone(this.filters),
                    endpoint = this.displayPeriod === 'grouped' ?
                        '/api/billings/grouped' :
                        '/api/billings/weekly'

                // params.users = _.map(params.users, 'id')

                axios.get(endpoint, { params })
                    .then(res => {
                        this.data = res.data.data
                        return res
                    })
            },

            fetchUserWeeklyBillingData(week, userId, reimbursable) {
                let params = _.clone(this.filters)
                delete params.users
                params.user_id = userId
                params.reimbursable = this.isBillingReimbVisible ? 1 : 0

                axios.get(`/api/billings/by-user`, {params}).then(res => {
                    if (week) {
                        this.userBilling = _.filter(res.data.data, {week})
                    } else {
                        this.userBilling = res.data.data
                    }

                    let username = this.userNameById(userId)
                    this.billingModalHeading = `Billing of ${username}`
                    this.isBillingModalActive = true
                    return res
                })
            },

            fetchUserGroupedBillingData(year, month, reimbursable) {
                
                axios.get(`/api/billings/by-user`, {params: {
                    month, year, reimbursable: this.isBillingReimbVisible ? 1 : 0
                }}).then(res => {
                    this.userBilling = _.filter(res.data.data)
                    this.billingModalHeading = `Billing`
                    this.isBillingModalActive = true
                    return res
                })
            },

            handleFiltersUpdate() {
                this.fetchData()
            },

            headingForWeek(week) {
                let month = moment()
                    .year(parseInt(this.filters.year))
                    .month(parseInt(this.filters.month) - 1)

                let weekStart = month.clone().date(week * 7 - 6),
                    weekEnd   = month.clone().date(week * 7)

                if (week == 4) {
                    weekEnd = weekStart.clone().endOf('month')
                }

                let format = 'MMMM Do'

                return weekStart.format(format) + ' - ' + weekEnd.format(format)
            },

            resetFilters() {
                this.filters = {
                    year: (new Date).getFullYear(),
                    month: moment().format('MM'),
                    team_id: null,
                    users: [],
                    reimbursable: null
                }
            },
        },

        computed: {
            ...mapGetters(['currentProjectId', 'years', 'months', 'teams', 'userNameById', 'isBillingReimbVisible']),

            isResetFiltersButtonVisible() {
                let f = this.filters

                return f.team_id || f.users.length > 0 || f.year != (new Date).getFullYear() || f.month != moment().format('MM')
            },

            week1() {
                return _.filter(this.data, {week: 1})
            },

            week2() {
                return _.filter(this.data, {week: 2})
            },

            week3() {
                return _.filter(this.data, {week: 3})
            },

            week4() {
                return _.filter(this.data, {week: 4})
            },

            displayPeriod() {
                let month = this.filters.month,
                    year = this.filters.year

                if (month && year && year != 'grouped') {
                    return 'weekly'
                }

                return 'grouped'
            },

            selectedMonth() {
                return _.find(this.months, {id: this.filters.month}).name
            }
        }
    }
</script>
